import Client from './client';

export default class ChannelBilledTransactionPairs extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(options = {}) {
    return this.makeRequest(`${this.host}/internal/billing/channel/billed/transaction/pairs`, options);
  }

  getByKey(key, options = {}) {
    return this.makeRequest(`${this.host}/internal/billing/channel/billed/transaction/pairs/${key}`, options);
  }

  putByKey(key, options = {}) {
    return this.makeRequest(`${this.host}/internal/billing/channel/billed/transaction/pairs/${key}`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteByKey(key, options = {}) {
    return this.makeRequest(`${this.host}/internal/billing/channel/billed/transaction/pairs/${key}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
